import React from 'react';
import Range from './Range';
import Line from './Line';
import { useTsRow } from '../hooks/useTimeseries';

const Cell = (props) => {
  const [tsMode, _] = useTsRow(props.rowData.id);
  if (tsMode) {
    return <Line {...props} />;
  }
  return <Range {...props} />;
};

export default Cell;
